import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{sq-walkthrough-popover class=this.popoverClassNames step=this.step close=(action \"close\") isActive=this.isActive}}", {
  moduleName: "@dashboard/shared-ui/components/setup-guide/walkthrough-popover.hbs"
});